/* unplugin-vue-components disabled */import { render } from "./UnicomInNetProtocol.vue?vue&type=template&id=d5ec9624"
import script from "./UnicomInNetProtocol.vue?vue&type=script&lang=js"
export * from "./UnicomInNetProtocol.vue?vue&type=script&lang=js"

import exportComponent from "E:\\myprogram\\52haoma_new\\new-haoma52\\haoma52-index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__